(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/vikinglotto.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/vikinglotto.js');

'use strict';

var _svs$numbergames;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const VIKINGLOTTO = {
  productId: (_svs$numbergames = svs.numbergames) === null || _svs$numbergames === void 0 || (_svs$numbergames = _svs$numbergames.productMapping) === null || _svs$numbergames === void 0 ? void 0 : _svs$numbergames.CONSTANTS.VIKINGLOTTO,
  rowPrice: 10,
  rowPriceMultipliers: [1],
  numbersMaxValue: 48,
  numbersMaxLength: 6,
  numbersExtraMaxValue: 5,
  numbersExtraMaxLength: 1,
  maxNumberOfRows: 12,
  usesJoker: true,
  defaultJokerPrice: 0,
  defaultPackage: 120,
  winConditions: [{
    numbers: 3
  }],
  hasSubscription: true,
  possibleDrawCounts: [{
    value: '1',
    label: '1 v'
  }, {
    value: '2',
    label: '2 v'
  }, {
    value: '3',
    label: '3 v'
  }, {
    value: '4',
    label: '4 v'
  }, {
    value: '5',
    label: '5 v'
  }, {
    value: '6',
    label: '6 v'
  }, {
    value: '7',
    label: '7 v'
  }, {
    value: '8',
    label: '8 v'
  }, {
    value: '9',
    label: '9 v'
  }, {
    value: '10',
    label: '10 v'
  }],
  PACKAGES: {
    60: {
      rows: 6
    },
    120: {
      rows: 12
    },
    240: {
      rows: 24
    }
  },
  SYSTEM: {
    LIMITS: {
      NUMBERS: {
        minRowLength: 6,
        maxRowLength: 12,
        combinationMinLength: {
          1: 7,
          2: 6,
          3: 6,
          4: 6,
          5: 6
        },
        combinationMaxLength: {
          1: 12,
          2: 11,
          3: 10,
          4: 10,
          5: 9
        }
      },
      NUMBERS_EXTRA: {
        minRowLength: 1,
        maxRowLength: 5,
        combinationMinLength: {
          6: 2,
          7: 1,
          8: 1,
          9: 1,
          10: 1,
          11: 1,
          12: 1
        },
        combinationMaxLength: {
          6: 5,
          7: 5,
          8: 5,
          9: 5,
          10: 4,
          11: 2,
          12: 1
        }
      }
    }
  }
};
const VIKINGLOTTO_SELFSERVICE = _objectSpread(_objectSpread({}, VIKINGLOTTO), {}, {
  defaultPackage: 60,
  possibleDrawCounts: [{
    value: '1',
    label: '1 v'
  }, {
    value: '5',
    label: '5 v'
  }, {
    value: '10',
    label: '10 v'
  }],
  PACKAGES: {
    60: {
      rows: 6
    },
    120: {
      rows: 12
    }
  }
});
if (svs.isServer) {
  module.exports = {
    VIKINGLOTTO,
    VIKINGLOTTO_SELFSERVICE
  };
} else {
  svs.numbergames.rules.VIKINGLOTTO = VIKINGLOTTO;
  svs.numbergames.rules.VIKINGLOTTO_SELFSERVICE = VIKINGLOTTO_SELFSERVICE;
}

 })(window);